import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, IconButton, Popover } from '@material-ui/core';
import { Auth } from 'aws-amplify'
import MenuItem from '@material-ui/core/MenuItem'
import AccountCircle from '@material-ui/icons/AccountCircle'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { currentUserSelector } from "store/current_user"
import styles from './styles.module.scss'

const Topbar = (props: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)
  const currentUser = useSelector(currentUserSelector)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)
  const handleMenuClose = () => setAnchorEl(null)
  const handleSignout = () => Auth.signOut()

  return (
    <AppBar
      {...props}
      className={styles.root}
    >
      <Toolbar className={styles.toolbar}>
        <div>
          <RouterLink to="/" className={styles.link}>
            管理画面
          </RouterLink>
        </div>
        <div>
          <IconButton edge="end" onClick={handleMenuOpen} color="inherit">
            <AccountCircle />
            <span className={styles.username}>{currentUser?.userName ?? "unknown"}</span>
            <ArrowDropDownIcon />
          </IconButton>
          <Popover
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 50, horizontal: 10 }}
            open={isMenuOpen}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleSignout}>ログアウト</MenuItem>
          </Popover>
        </div>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
